import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';
import {
    STROLLER_CARD_RECOMMENDED_CHOICE_HAPPY_MEDIUM,
    STROLLER_CARD_RECOMMENDED_CHOICE_POPULAR,
    STROLLER_CARD_RECOMMENDED_CHOICE_TOP,
    STROLLER_DETAIL_RECOMMENDED_CHOICE_DESC_LI1,
    STROLLER_DETAIL_RECOMMENDED_CHOICE_DESC_LI2,
    STROLLER_DETAIL_RECOMMENDED_CHOICE_DESC_LI3,
    STROLLER_DETAIL_RECOMMENDED_CHOICE_DESC_P1,
    STROLLER_DETAIL_RECOMMENDED_CHOICE_OF_categories,
} from 'mk/autogenerated/translations/StrollerDetailHeadlineAndBadges.2bf656abf41d00912fea30b38fa2a82e'
import styles from 'mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.mscss';
import { FEATURES_LIST } from 'mk2/apps/strollers/features';
import { StrollerEntity } from 'mk2/apps/strollers/schemas';
import { Btn, BtnLayout, BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { Interpolate } from 'mk2/components/Interpolate';
import { interpolate } from 'mk2/services/i18n';
import React, { useState } from 'react';

const FORMATTING_COMPONENTS = [
    <strong key={0} />,
    <span className={styles.StrollersDetail__recommendedChoiceDesc__top} key={1} />,
    <span className={styles.StrollersDetail__recommendedChoiceDesc__happyMedium} key={2} />,
    <span className={styles.StrollersDetail__recommendedChoiceDesc__popular} key={3} />,
];

export const StrollerDetailHeadlineAndBadges: React.FunctionComponent<{ stroller: StrollerEntity }> = ({ stroller }) => {
    const [showRecommendedChoiceDesc, setRecommendedChoiceDesc] = useState(false);

    if (!stroller) {
        return null;
    }

    const recommendedChoiceBadge = stroller.features.recommended_choice ? (
        <span
            className={cx(
                styles.StrollersDetail__badges__badge,
                stroller.features.recommended_choice === 'top' &&
                    styles['StrollersDetail__badges__badge--top'],
                stroller.features.recommended_choice === 'happy medium' &&
                    styles['StrollersDetail__badges__badge--happyMedium'],
                stroller.features.recommended_choice === 'popular' &&
                    styles['StrollersDetail__badges__badge--popular'],
            )}
        >
            {stroller.features.recommended_choice === 'top'
                ? STROLLER_CARD_RECOMMENDED_CHOICE_TOP
                : stroller.features.recommended_choice === 'happy medium'
                ? STROLLER_CARD_RECOMMENDED_CHOICE_HAPPY_MEDIUM
                : stroller.features.recommended_choice === 'popular'
                ? STROLLER_CARD_RECOMMENDED_CHOICE_POPULAR
                : null}
        </span>
    ) : null;

    function onToggleRecommendedChoiceDesc() {
        setRecommendedChoiceDesc(!showRecommendedChoiceDesc);
    }

    return (
        <div className={styles.StrollersDetail__badgesAndHeadline}>
            <div className={styles.StrollersDetail__badgesAndHeadline__main}>
                <h1 className={styles.StrollersDetail__headline}>{stroller.name + ' '}</h1>
                {stroller.features.recommended_choice && (
                        <div className={styles.StrollersDetail__badges}>
                            {recommendedChoiceBadge}
                            {stroller.features.recommended_choice_of_categories && (
                                <Btn
                                    type={BtnType.GreyText}
                                    layout={BtnLayout.Icon}
                                    icon={faInfoCircle}
                                    onClick={onToggleRecommendedChoiceDesc}
                                    sidePadding={BtnSidePadding.None}
                                    className={styles.StrollersDetail__badges__info}
                                />
                            )}
                        </div>
                )}
            </div>
            {showRecommendedChoiceDesc &&
                <div className={styles.StrollersDetail__recommendedChoiceDesc}>
                    <div className={styles.StrollersDetail__recommendedChoiceDesc__firstLine}>
                        {recommendedChoiceBadge}
                        &nbsp;
                        {interpolate(
                            STROLLER_DETAIL_RECOMMENDED_CHOICE_OF_categories, {
                                categories: stroller.features.recommended_choice_of_categories
                                    .map(cat => FEATURES_LIST.recommended_choice_of_categories.OPTIONS[cat])
                                    .join(', ').toLowerCase(),
                            },
                        )}
                    </div>
                    <div>
                        <Interpolate
                            i18nKey={STROLLER_DETAIL_RECOMMENDED_CHOICE_DESC_P1}
                            components={FORMATTING_COMPONENTS}
                        />
                    </div>
                    <ul>
                        <li>
                            <Interpolate
                                i18nKey={STROLLER_DETAIL_RECOMMENDED_CHOICE_DESC_LI1}
                                components={FORMATTING_COMPONENTS}
                            />
                        </li>
                        <li>
                            <Interpolate
                                i18nKey={STROLLER_DETAIL_RECOMMENDED_CHOICE_DESC_LI2}
                                components={FORMATTING_COMPONENTS}
                            />
                        </li>
                        <li>
                            <Interpolate
                                i18nKey={STROLLER_DETAIL_RECOMMENDED_CHOICE_DESC_LI3}
                                components={FORMATTING_COMPONENTS}
                            />
                        </li>
                    </ul>
                </div>
            }
        </div>
    );
};

StrollerDetailHeadlineAndBadges.displayName = 'StrollerDetailHeadlineAndBadges';
